<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)"
     (pointerleave)="onPointerUp($event)">

  <defs>
    <radialGradient id="fl-panel" cx="50%" cy="30%" r="90%">
      <stop offset="0%" stop-color="#3a2a6b" />
      <stop offset="55%" stop-color="#241a4d" />
      <stop offset="100%" stop-color="#160f33" />
    </radialGradient>
    <linearGradient id="fl-rocket" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#eaf6ff" />
      <stop offset="100%" stop-color="#a9c3e6" />
    </linearGradient>
    <linearGradient id="fl-flame" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#ffe259" />
      <stop offset="100%" stop-color="#ff7a18" />
    </linearGradient>
    <linearGradient id="fl-fill" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#7ef0ff" />
      <stop offset="100%" stop-color="#ffd34d" />
    </linearGradient>
    <linearGradient id="fl-fill-wrong" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color="#ff8a80" />
      <stop offset="100%" stop-color="#e53935" />
    </linearGradient>
    <filter id="fl-glow" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="6" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
  </defs>

  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0"
        fill="url(#fl-panel)" stroke="rgba(255,255,255,0.14)" stroke-width="2" />

  <!-- Starfield -->
  <g fill="#ffffff">
    <circle cx="150" cy="70" r="2" opacity="0.5" /><circle cx="400" cy="55" r="1.6" opacity="0.35" />
    <circle cx="640" cy="80" r="2.2" opacity="0.55" /><circle cx="860" cy="60" r="1.5" opacity="0.4" />
    <circle cx="930" cy="140" r="2" opacity="0.5" /><circle cx="90" cy="150" r="1.6" opacity="0.4" />
    <circle cx="520" cy="120" r="1.4" opacity="0.35" />
  </g>

  <!-- Hint subdivisions -->
  <g *ngIf="hintVisible" class="hint-ticks">
    <line *ngFor="let x of hintTicks" [attr.x1]="x" [attr.y1]="LINE_Y - 16" [attr.x2]="x" [attr.y2]="LINE_Y + 16"
          stroke="#7ef0ff" stroke-width="3" opacity="0.55" />
  </g>

  <!-- Number line -->
  <g class="numline" stroke="#eef3ff" stroke-width="4" stroke-linecap="round">
    <line [attr.x1]="X0 - 40" [attr.y1]="LINE_Y" [attr.x2]="X1 + 40" [attr.y2]="LINE_Y" />
    <!-- arrowheads -->
    <polyline [attr.points]="(X0 - 40) + ',' + (LINE_Y - 12) + ' ' + (X0 - 56) + ',' + LINE_Y + ' ' + (X0 - 40) + ',' + (LINE_Y + 12)" fill="none" />
    <polyline [attr.points]="(X1 + 40) + ',' + (LINE_Y - 12) + ' ' + (X1 + 56) + ',' + LINE_Y + ' ' + (X1 + 40) + ',' + (LINE_Y + 12)" fill="none" />
    <!-- end ticks -->
    <line [attr.x1]="X0" [attr.y1]="LINE_Y - 20" [attr.x2]="X0" [attr.y2]="LINE_Y + 20" />
    <line [attr.x1]="X1" [attr.y1]="LINE_Y - 20" [attr.x2]="X1" [attr.y2]="LINE_Y + 20" />
  </g>
  <text class="end-label" [attr.x]="X0" [attr.y]="LINE_Y + 52" text-anchor="middle">0</text>
  <text class="end-label" [attr.x]="X1" [attr.y]="LINE_Y + 52" text-anchor="middle">1</text>

  <!-- Aim beam + marker (hidden once the answer is correct) -->
  <g *ngIf="!solvedState">
    <line class="aim-beam" [attr.x1]="rocketX" [attr.y1]="LINE_Y" [attr.x2]="rocketX" [attr.y2]="TRACK_Y - 34" />
    <circle class="aim-dot" [attr.cx]="rocketX" [attr.cy]="LINE_Y" r="9" />
  </g>

  <!-- Answer reveal: the fraction as partitioned equal parts, first
       `numerator` filled — its right edge lands on the answer point -->
  <g *ngIf="revealed" class="reveal">
    <!-- boundary ticks on the line -->
    <line *ngFor="let x of revealTicks" class="reveal-tick"
          [attr.x1]="x" [attr.y1]="LINE_Y - 15" [attr.x2]="x" [attr.y2]="LINE_Y + 15" />
    <!-- segmented fraction bar above the line -->
    <rect *ngFor="let c of revealCells" class="reveal-cell" [class.filled]="c.filled"
          [attr.x]="c.x + 2" [attr.y]="BAR_Y - BAR_H/2" [attr.width]="c.w - 4" [attr.height]="BAR_H" rx="6"
          [style.animation-delay.ms]="c.filled ? c.index * 70 : 0" />
    <!-- connector from the filled length's edge down to the point -->
    <line class="reveal-pole" [attr.x1]="targetX" [attr.y1]="BAR_Y + BAR_H/2" [attr.x2]="targetX" [attr.y2]="LINE_Y" />
    <!-- the fraction, written at the point -->
    <g class="reveal-label" [attr.transform]="'translate(' + targetX + ',' + (BAR_Y - BAR_H/2 - 40) + ')'">
      <text class="rl-num" x="0" y="-6" text-anchor="middle">{{ round?.numerator }}</text>
      <line x1="-15" y1="2" x2="15" y2="2" stroke="#ffffff" stroke-width="3" stroke-linecap="round" />
      <text class="rl-den" x="0" y="30" text-anchor="middle">{{ round?.denominator }}</text>
    </g>
  </g>

  <!-- Miss puff -->
  <circle *ngIf="missPuff" class="miss-puff" [attr.cx]="missPuff.x" [attr.cy]="missPuff.y" r="16" />

  <!-- Wrong launch: show what the child DID — the red length from 0 to
       where they launched, marked with an ✕ (never the answer). -->
  <g *ngIf="guessResult" class="guess">
    <rect class="guess-bar" [attr.x]="X0" [attr.y]="BAR_Y - BAR_H/2"
          [attr.width]="guessResult.x - X0" [attr.height]="BAR_H" rx="8" />
    <text class="guess-label" [attr.x]="(X0 + guessResult.x) / 2" [attr.y]="BAR_Y - BAR_H/2 - 12"
          text-anchor="middle">{{ currLang === 'ar' ? 'أنت هنا' : 'you' }}</text>
    <g class="guess-mark">
      <circle [attr.cx]="guessResult.x" [attr.cy]="LINE_Y" r="15" />
      <text [attr.x]="guessResult.x" [attr.y]="LINE_Y" text-anchor="middle" dominant-baseline="central">✕</text>
    </g>
  </g>

  <!-- Planted star (hit) -->
  <g *ngIf="planted">
    <circle class="planted-glow" [attr.cx]="planted.x" [attr.cy]="LINE_Y" r="20" filter="url(#fl-glow)" />
    <text class="planted-star" [attr.x]="planted.x" [attr.y]="LINE_Y" text-anchor="middle" dominant-baseline="central">⭐</text>
  </g>

  <!-- Sparkles -->
  <g *ngIf="solvedState">
    <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [style.animation-delay.ms]="s.delay" fill="#fff4b0" />
  </g>

  <!-- Rocket -->
  <g class="rocket" [class.dragging]="!launching" [class.flying]="launching"
     [attr.transform]="rocketTransform" (pointerdown)="onRocketDown($event)">
    <!-- big invisible grab pad -->
    <rect x="-46" y="-60" width="92" height="150" fill="transparent" />
    <!-- flame -->
    <path class="flame" d="M -14 44 Q 0 96 14 44 Q 0 60 -14 44 Z" fill="url(#fl-flame)" />
    <!-- fins -->
    <path d="M -16 22 L -34 52 L -16 46 Z" fill="#ff8a65" />
    <path d="M 16 22 L 34 52 L 16 46 Z" fill="#ff8a65" />
    <!-- body -->
    <path d="M 0 -58 C 22 -34 22 10 16 44 L -16 44 C -22 10 -22 -34 0 -58 Z" fill="url(#fl-rocket)" stroke="#5c6bc0" stroke-width="3" />
    <!-- window -->
    <circle cx="0" cy="-6" r="11" fill="#7ef0ff" stroke="#3a4a7a" stroke-width="3" />
  </g>

  <!-- Brief red wash to sell the "wrong" feeling -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0" />
</svg>
